// This file contains the main JavaScript code for the Film Development Wizard
let currentStep = 1;
let totalSteps = 6;
let userSelections = {};

// Initialize the wizard when the DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  // Reset any existing state
  resetWizardState();
  
  // Setup initial state
  currentStep = 1;
  userSelections = {};
  
  // Make sure all buttons have proper data attributes
  ensureButtonAttributes();
  
  // Update navigation elements
  updateNavigation();
  
  // Show the first step
  document.getElementById('step1').classList.add('active');
  
  // Log initialization complete
  console.log("Film Development Wizard initialized");
  console.log("Wizard ID:", window.wizardSettings?.wizardId);
});

// Helper function to reset wizard state completely
function resetWizardState() {
  document.querySelectorAll('.step-circle').forEach((circle, index) => {
    circle.classList.remove('active');
    if (index === 0) circle.classList.add('active');
  });
  
  document.querySelectorAll('.step').forEach(step => {
    step.classList.remove('active');
  });
  
  document.getElementById('step1').classList.add('active');
  currentStep = 1;
  userSelections = {};
}

// Helper to reattach event handlers
function attachEventHandlers() {
  // Make sure all buttons in step1 have working event handlers
  const step1Buttons = document.querySelectorAll('#step1 button');
  step1Buttons.forEach(button => {
    const buttonContent = button.textContent.trim();
    // Extract the film type from the button text content
    let filmType;
    if (buttonContent.includes('35mm')) {
      filmType = '35mm';
    } else if (buttonContent.includes('120')) {
      filmType = '120';
    } else if (buttonContent.includes('110')) {
      filmType = '110';
    } else if (buttonContent.includes('APS')) {
      filmType = 'APS';
    } else if (buttonContent.includes('Disposable')) {
      filmType = 'Disposable Camera';
    } else {
      filmType = buttonContent.split('\n')[0].trim();
    }
    
    button.onclick = function() {
      console.log("Step 1 button clicked:", filmType);
      nextStep(1, filmType);
    };
  });
}

// Helper to check if a film type is disabled
function isFilmTypeDisabled(filmType) {
  const settings = window.wizardSettings || {};
  switch(filmType.toLowerCase()) {
    case '35mm':
      return settings.film35mmDisabled;
    case '120':
      return settings.film120Disabled;
    case '110':
      return settings.film110Disabled;
    case 'aps':
      return settings.filmAPSDisabled;
    case 'disposable camera':
      return settings.filmDisposableDisabled;
    default:
      return false;
  }
}

// Helper to check if a processing option is disabled for a film type
function isProcessingDisabled(filmType, processingType) {
  const settings = window.wizardSettings || {};
  const filmTypeLower = filmType.toLowerCase();
  
  // Handle disposable camera special case
  if (filmTypeLower === 'disposable camera' && settings.filmDisposableBasicOnly) {
    return !processingType.includes('C-41') && !processingType.includes('Black-and-White');
  }
  
  // Check film-specific processing restrictions
  if (processingType.includes('E-6')) {
    switch(filmTypeLower) {
      case '35mm':
        return settings.film35mmDisableE6;
      case '120':
        return settings.film120DisableE6;
      case '110':
        return settings.film110DisableE6;
      case 'aps':
        return settings.filmAPSDisableE6;
      default:
        return false;
    }
  } else if (processingType.includes('Cross Processing')) {
    switch(filmTypeLower) {
      case '35mm':
        return settings.film35mmDisableCross;
      case '120':
        return settings.film120DisableCross;
      case '110':
        return settings.film110DisableCross;
      case 'aps':
        return settings.filmAPSDisableCross;
      default:
        return false;
    }
  } else if (processingType.includes('ECN-2')) {
    switch(filmTypeLower) {
      case '35mm':
        return settings.film35mmDisableECN2;
      case '120':
        return settings.film120DisableECN2;
      default:
        return true; // ECN-2 only available for 35mm and 120
    }
  }
  
  return false;
}

// Helper to set up processing options
function setupProcessingOptions() {
  console.log("Setting up processing options");
  let filmType = userSelections['step1'];
  const originalFilmType = userSelections['step1_original'];
  
  console.log("Current film type:", filmType, "Original:", originalFilmType || "None");
  
  // Get settings from Shopify section if available
  const settings = window.wizardSettings || {};
  
  // Disable film type buttons based on settings
  const step1Buttons = document.querySelectorAll('#step1 button');
  step1Buttons.forEach(button => {
    const buttonText = button.textContent.trim();
    if (isFilmTypeDisabled(buttonText)) {
      button.disabled = true;
      button.style.opacity = "0.5";
      button.style.cursor = "not-allowed";
      button.classList.add('disabled-option');
      
      // Add tooltip explaining why this option is disabled
      const tooltipDiv = button.querySelector('.tooltip-text');
      if (tooltipDiv) {
        tooltipDiv.innerHTML += "<br><strong>Temporarily unavailable.</strong>";
      }
    }
  });
  
  // Disable scan quality options based on settings
  if (settings.disableHighResBMP || settings.disableHighResTIFF) {
    const step3Buttons = document.querySelectorAll('#step3 button');
    step3Buttons.forEach(button => {
      const buttonText = button.textContent.trim();
      if ((settings.disableHighResBMP && buttonText.includes('BMP')) ||
          (settings.disableHighResTIFF && buttonText.includes('TIFF'))) {
        button.disabled = true;
        button.style.opacity = "0.5";
        button.style.cursor = "not-allowed";
        button.classList.add('disabled-option');
        
        // Add tooltip explaining why this option is disabled
        const tooltipDiv = button.querySelector('.tooltip-text');
        if (tooltipDiv) {
          tooltipDiv.innerHTML += "<br><strong>Temporarily unavailable.</strong>";
        }
      }
    });
  }
  
  // Handle processing options
  const step2Buttons = document.querySelectorAll('#step2 button');
  console.log(`Found ${step2Buttons.length} buttons in step 2`);
  
  // Store the number of enabled buttons to check if we need to fix them
  let enabledButtonCount = 0;
  
  step2Buttons.forEach(button => {
    const buttonText = button.textContent.trim();
    console.log("Button text:", buttonText);
    
    // Make sure all buttons have the data attribute
    if (!button.hasAttribute('data-processing-type')) {
      button.setAttribute('data-processing-type', buttonText);
    }
    
    // IMPORTANT: Reset all buttons first to ensure they start in a clean state
    button.disabled = false;
    button.style.opacity = "1";
    button.style.cursor = "pointer";
    button.classList.remove('disabled-option');
    
    // Check if button should be disabled based on settings
    if (isProcessingDisabled(filmType, buttonText)) {
      button.disabled = true;
      button.style.opacity = "0.5";
      button.style.cursor = "not-allowed";
      button.classList.add('disabled-option');
      
      // Add tooltip explaining why this option is disabled
      const tooltipDiv = button.querySelector('.tooltip-text');
      if (tooltipDiv) {
        tooltipDiv.innerHTML += "<br><strong>Temporarily unavailable for " + filmType + ".</strong>";
      }
    } else {
      enabledButtonCount++;
    }
  });
  
  // If no buttons were enabled (shouldn't happen normally), force-enable the primary options
  if (enabledButtonCount === 0) {
    console.error("No buttons were enabled! Forcing primary options to be enabled");
    step2Buttons.forEach(button => {
      const processingType = button.getAttribute('data-processing-type');
      if (processingType === "Color (C-41)" || processingType === "Black-and-White") {
        button.disabled = false;
        button.style.opacity = "1";
        button.style.cursor = "pointer";
        button.classList.remove('disabled-option');
        console.log(`Forcing ${processingType} to be enabled`);
      }
    });
  }
}

function nextStep(currentStepNumber, choice) {
  console.log("nextStep called:", currentStepNumber, choice);
  
  // Hide the current step
  const currentElement = document.getElementById(`step${currentStepNumber}`);
  if (currentElement) {
    currentElement.classList.remove('active');
    
    // Update selected button styling
    const buttons = currentElement.querySelectorAll('button');
    buttons.forEach(button => button.classList.remove('selected'));
    
    buttons.forEach(button => {
      const buttonText = button.textContent.trim();
      if (currentStepNumber === 1) {
        const imgAlt = button.querySelector('img')?.alt;
        if ((imgAlt && imgAlt.includes(choice)) || buttonText.includes(choice)) {
          button.classList.add('selected');
          console.log("Selected button in step 1:", choice);
        }
      } else if (buttonText === choice || buttonText.includes(choice) || choice.includes(buttonText)) {
        button.classList.add('selected');
      }
    });
  }

  // Clear subsequent step selections when moving forward
  for (let i = currentStepNumber + 1; i <= totalSteps; i++) {
    delete userSelections[`step${i}`];
    if (currentStepNumber < 5) {
      delete userSelections['step5_material'];
      delete userSelections['step5_quantity'];
    }
  }

  // Store the selection as-is (no longer converting Disposable Camera to 35mm)
  userSelections[`step${currentStepNumber}`] = choice;

  // Special handling for film types that should skip resolution step
  if (currentStepNumber === 2 && 
      (userSelections['step1'] === '110' || userSelections['step1'] === 'APS')) {
    // Set default scan method and resolution, skip to step 4 (prints)
    userSelections['step3'] = 'Scan and Email';
    userSelections['step4'] = 'Standard Resolution';
    currentStep = 4;
  } 
  // Special handling for print choices
  else if (currentStepNumber === 4 && choice === "No Prints") {
    currentStep = 5;  // Proceed to shipping options
  } else {
    currentStep = currentStepNumber + 1;
  }

  // Debug log which step we're moving to
  console.log("Moving to step:", currentStep);
  console.log("Current selections:", userSelections);

  // When switching from step 1 to 2, check if processing options should be disabled
  if (currentStepNumber === 1) {
    setupProcessingOptions();
  }

  // Show summary or move to next step
  if (currentStep === totalSteps) {
    showSummary();
  } else {
    const nextElement = document.getElementById(`step${currentStep}`);
    if (nextElement) {
      nextElement.classList.add('active');
      nextElement.querySelectorAll('button').forEach(button => button.classList.remove('selected'));
      
      // If we are moving to step 5, update the shipping options
      if (currentStep === 5) {
        updateShippingOptions();
      }
    }
  }

  // Update UI navigation elements
  updateNavigation();
}

function previousStep() {
  if (currentStep === 1) return;

  const currentElement = document.getElementById(`step${currentStep}`);
  if (currentElement) {
    currentElement.classList.remove('active');
  }

  document.getElementById('summarySection').style.display = 'none';

  // Special handling for sub-steps
  if (currentStep === 42) {
    currentStep = 41;
    const step4a = document.getElementById('step4a');
    step4a.classList.add('active');
    document.getElementById('step4b').classList.remove('active');
    
    if (userSelections['step4_material']) {
      const buttons = step4a.querySelectorAll('button');
      buttons.forEach(button => {
        button.classList.remove('selected');
        if (button.textContent.trim() === userSelections['step4_material']) {
          button.classList.add('selected');
        }
      });
    }
  } else if (currentStep === 41) {
    currentStep = 4;
    const step4 = document.getElementById('step4');
    step4.classList.add('active');
    document.getElementById('step4a').classList.remove('active');
    
    const buttons = step4.querySelectorAll('button');
    buttons.forEach(button => {
      button.classList.remove('selected');
      if (button.textContent.includes('Yes')) {
        button.classList.add('selected');
      }
    });
  } else if (currentStep === 51) {
    currentStep = 5;
    const step5 = document.getElementById('step5');
    step5.classList.add('active');
    document.getElementById('step5a').classList.remove('active');
    
    const buttons = step5.querySelectorAll('button');
    buttons.forEach(button => {
      button.classList.remove('selected');
      if (button.textContent.includes('Send Negatives Back')) {
        button.classList.add('selected');
      }
    });
  } 
  // Special handling for going from step 4 to step 2 (skipping resolution step) for 110 and APS
  else if (currentStep === 4 && 
           (userSelections['step1'] === '110' || userSelections['step1'] === 'APS')) {
    currentStep = 2;
    const step2 = document.getElementById('step2');
    step2.classList.add('active');
    
    if (userSelections['step2']) {
      const buttons = step2.querySelectorAll('button');
      buttons.forEach(button => {
        button.classList.remove('selected');
        const buttonText = button.textContent.trim();
        if (buttonText === userSelections['step2'] || 
            buttonText.includes(userSelections['step2']) || 
            userSelections['step2'].includes(buttonText)) {
          button.classList.add('selected');
        }
      });
    }
  }
  else {
    currentStep -= 1;
    
    const previousElement = document.getElementById(`step${currentStep}`);
    if (previousElement) {
      previousElement.classList.add('active');

      // If we are navigating back to step 5, ensure options are correctly set
      if (currentStep === 5) {
          updateShippingOptions();
      }
            
      const previousChoice = userSelections[`step${currentStep}`];
      
      if (previousChoice) {
        const buttons = previousElement.querySelectorAll('button');
        buttons.forEach(button => {
          button.classList.remove('selected');
          const buttonText = button.textContent.trim();
          
          if (currentStep === 1) {
            const imgAlt = button.querySelector('img')?.alt;
            // Handle original selection for disposable cameras
            const originalChoice = userSelections['step1_original'] || previousChoice;
            if (imgAlt && (imgAlt.includes(previousChoice) || imgAlt.includes(originalChoice))) {
              button.classList.add('selected');
            }
          } else if (buttonText === previousChoice || buttonText.includes(previousChoice) || previousChoice.includes(buttonText)) {
            button.classList.add('selected');
          }
        });
      }
    }
  }

  updateNavigation();
}

function showSummary() {
  // Hide all steps
  document.querySelectorAll('.step').forEach(step => {
    step.classList.remove('active');
  });
  
  // Show the summary step
  const summaryStep = document.getElementById('summary');
  summaryStep.classList.add('active');
  
  // Update the selections list
  updateSelectionsList();
  
  // Show the summary section
  const summarySection = document.getElementById('summarySection');
  if (summarySection) {
    summarySection.style.display = 'block';
  }
}

function updateSelectionsList() {
  const selectionList = document.getElementById('selectionList');
  if (!selectionList) return;
  
  selectionList.innerHTML = '';
  
  // Create a mapping of step names to display labels
  const stepLabels = {
    'step1': 'Film Type',
    'step2': 'Processing',
    'step3': 'Resolution',
    'step4': 'Prints',
    'step4_material': 'Print Material',
    'step4_quantity': 'Print Quantity',
    'step5': 'Shipping',
    'step5_shipping': 'Shipping Method'
  };
  
  Object.entries(userSelections).forEach(([step, choice]) => {
    if (!choice || step.includes('original')) return;
    
    // Skip step5 if we have a step5_shipping value (to avoid redundancy)
    if (step === 'step5' && userSelections['step5_shipping'] && choice === 'Send Negatives Back') return;
    
    const li = document.createElement('li');
    const label = stepLabels[step] || step;
    
    li.innerHTML = `
      <span class="step-label">${label}:</span>
      <span class="step-value">${choice}</span>
    `;
    
    selectionList.appendChild(li);
  });
}

function resetWizard() {
  currentStep = 1;
  Object.keys(userSelections).forEach(key => delete userSelections[key]);
  
  const notesTextarea = document.getElementById('orderNotes');
  if (notesTextarea) {
    notesTextarea.value = '';
  }
  
  document.querySelectorAll('.step').forEach(step => {
    step.classList.remove('active');
    step.querySelectorAll('button').forEach(button => button.classList.remove('selected'));
  });
  document.getElementById('step1').classList.add('active');
  
  updateNavigation();
}

// Function to ensure all buttons have proper attributes
function ensureButtonAttributes() {
  // Step 2 - Processing types
  document.querySelectorAll('#step2 button').forEach(button => {
    if (!button.hasAttribute('data-processing-type')) {
      const buttonText = button.textContent.trim();
      button.setAttribute('data-processing-type', buttonText);
      console.log(`Added data-processing-type "${buttonText}" to button`);
    }
  });
  
  // Step 3 - Scan methods
  document.querySelectorAll('#step3 button').forEach(button => {
    if (!button.hasAttribute('data-scan-method')) {
      const buttonText = button.textContent.trim();
      button.setAttribute('data-scan-method', buttonText);
      console.log(`Added data-scan-method "${buttonText}" to button`);
    }
  });
  
  // Step 4 - Resolutions
  document.querySelectorAll('#step4 button').forEach(button => {
    if (!button.hasAttribute('data-resolution')) {
      const buttonText = button.textContent.trim().split(' +')[0]; // Remove "+$X" part
      button.setAttribute('data-resolution', buttonText);
      console.log(`Added data-resolution "${buttonText}" to button`);
    }
  });
}
